import React, { useCallback } from 'react'
import { PaginationSizeProps } from './types'

/**
 * Componente selector de tamaño de página
 * Estilo minimalista y discreto
 */
const PaginationSize: React.FC<PaginationSizeProps> = ({
  pageSize,
  onPageSizeChange,
  onPageChange,
  options = [30, 50, 60, 80, 100],
  isLoading = false,
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const newSize = Number(e.target.value)
      onPageSizeChange(newSize)
      onPageChange(1) // Resetear a primera página al cambiar tamaño
    },
    [onPageSizeChange, onPageChange]
  )

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-gray-600 whitespace-nowrap">Mostrar:</span>
      <select
        value={pageSize}
        onChange={handleChange}
        disabled={isLoading}
        className="px-2 py-1 text-xs border border-gray-200 rounded-lg 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
                   disabled:bg-gray-50 disabled:cursor-not-allowed
                   transition-all duration-200 cursor-pointer"
        aria-label="Elementos por página"
      >
        {options.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
      <span className="text-xs text-gray-600 whitespace-nowrap">por página</span>
    </div>
  )
}

export default React.memo(PaginationSize)

